/* eslint camelcase: 0 */
export const DEFAULT_NOTIFICATION_SUCCESS = {
  type: 'default',
  insert: 'top',
  container: 'top-right',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut'],
  dismiss: {
    duration: 2500,
    showIcon: true,
  },
};

/**
 * Catalog sections
 */
export const CATALOG_IMPORT_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.catalog_import_success,
  };
};

export const CATALOG_IMPORT_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.catalog_import_error,
    type: 'danger',
  };
};

export const CATALOG_IMPORT_GROUPS_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.catalog_import_groupes_success,
  };
};

export const CATALOG_IMPORT_GROUPS_FAIL = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: translations?.catalog_import_groups_fail
  };
};

export const CATALOG_PAGE_CONFIG_UPDATE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.settings_save_success,
  };
};

export const CATALOG_PAGE_CONFIG_UPDATE_FAIL = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: translations?.settings_save_error,
  };
};

/**
 * Product sections
 */
export const PRODUCT_SAVE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.product_save_success
  };
};

export const PRODUCT_DELETE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.product_delete_success,
  };
};

export const PRODUCT_COPY_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.product_copy_success,
  };
};

export const PRODUCT_SELECTED_DELETE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.products_delete_success,
  };
};

export const PRODUCT_DELETE_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.product_delete_error,
    type: 'danger',
  };
};

export const PRODUCT_COPY_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.product_copy_fail,
    type: 'danger',
  };
};

export const PRODUCT_SELECTED_MOVE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.product_moves_success,
  };
};

export const PRODUCT_SELECTED_MOVE_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.product_moves_error,
    type: 'danger',
  };
};

export const PRODUCT_SELECTED_COPY_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.product_copy_success,
  };
};

export const PRODUCT_SELECTED_COPY_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.product_copy_error,
    type: 'danger',
  };
};

export const PRODUCT_SELECTED_DELETE_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.products_delete_error,
    type: 'danger',
  };
};

export const PRODUCT_SAVE_FAILED = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message: translations?.product_save_error,
    type: 'danger',
  };
};

/**
 * Индексация товаров
 */
export const PRODUCTS_INDEX_NOTIFICATION_ERROR = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message:
      translations?.products_index_error,
    type: 'danger',
  };
};

/**
 * Индексация данных
 */
export const DATA_INDEX_NOTIFICATION_ERROR = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message:
      translations?.products_index_error,
    type: 'danger',
  };
};

/**
 * Общее
 */
export const COMMON_DATA_UPDATE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.common_success_message,
  };
};

export const COMMON_DATA_DELETE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.common_delete_success,
  };
};

export const COMMON_DATA_ARCHIVE_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.common_archive_success,
  };
};

export const COMMON_DATA_UPDATE_FAIL = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: translations?.common_update_error,
  };
};

/**
 * Ошибка: попытка выдать группе разрешение с путём, который уже есть в этой
 * группе (инвариант «один path на группу»).
 */
export const PERMISSION_PATH_IN_GROUP_FAIL = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: translations?.user_permission_path_already_in_group,
  };
};

export const COMMON_DATA_DELETE_FAIL = (translations, key) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: key ? translations[key] : translations?.common_delete_error
  };
};

export const COMMON_DATA_ARCHIVE_FAIL = (translations, key) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: key ? translations[key] : translations?.common_archive_error
  };
};

/**
 * Возвраты
 */
export const REFUND_SUCCESS = (translations, amount) => {
  const base = translations?.refund_success_message || 'Refund completed';
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    type: 'success',
    title: translations?.formManagement_successfully,
    message: amount != null ? `${base}: ${amount}` : base,
  };
};

export const REFUND_PARTIAL = (translations, result) => {
  const succeededCount = result?.succeeded?.length ?? 0;
  const failedCount = result?.failed?.length ?? 0;
  const failedMessages = (result?.failed || []).map((f) => f.message).filter(Boolean).join('; ');
  const okLabel = translations?.refund_partial_succeeded || 'succeeded';
  const failedLabel = translations?.refund_partial_failed || 'failed';
  const summary = `${succeededCount} ${okLabel}, ${failedCount} ${failedLabel}`;
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    type: 'warning',
    title: translations?.refund_partial_title || 'Partial refund',
    message: failedMessages ? `${summary}: ${failedMessages}` : summary,
    dismiss: {
      duration: 8000,
      showIcon: true,
    },
  };
};

export const REFUND_FAIL = (translations, message) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    type: 'danger',
    message: message || translations?.common_update_error,
  };
};

/**
 * Предупреждения
 */
export const DISK_SPACE_NO_LEFT_WARNING = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    id: 'disk_space_no_left',
    dismiss: {
      duration: 0,
      showIcon: true,
    },
    title: translations?.common_notification_warning_title,
    type: 'warning',
    message: translations?.disk_space_no_left_warning,
  };
};

export const RECORD_EXCEEDS_WARNING = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    // id: 'record_exceeds',
    // dismiss: {
    //   duration: 0,
    //   showIcon: true,
    // },
    title: translations?.common_notification_warning_title,
    type: 'warning',
    message: translations?.records_exceeds_warning,
  };
};

export const START_CERT_DELETION_WARNING = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    id: 'cert_deletion',
    title: translations?.common_notification_warning_title,
    type: 'warning',
    message: translations?.deletion_certs_warning,
  };
};

export const ADMIN_EXCEEDS_WARNING = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    id: 'admin_exceeds',
    dismiss: {
      duration: 0,
      showIcon: true,
    },
    title: translations?.common_notification_warning_title,
    type: 'warning',
    message: translations?.admins_exceeds_warning,
  };
};

export const UPLOAD_IMAGE_SIZE_EXCEEDED_WARNING = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    id: 'files_exceeds',
    dismiss: {
      duration: 0,
      showIcon: true,
    },
    title: translations?.common_notification_warning_title,
    type: 'warning',
    message: translations?.upload_image_size_exceeded_warning,
  };
};

export const FORBIDDEN_RESOURCE_WARNING = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    id: 'forbidden_resource_warning',
    dismiss: {
      duration: 0,
      showIcon: true,
    },
    title: translations?.common_notification_warning_title || 'Warning',
    type: 'warning',
    message: translations?.forbidden_resource_warning,
  };
};

export const COMMON_OPERATION_FAILED = (translations, message) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message,
    type: 'danger',
  };
};

export const COMMON_OPERATION_SUCCESS = (translations, message) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message
  };
};

export const COMMON_OPERATION_WARNING = (translations, message) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.warning,
    type: 'warning',
    message
  };
};

export const FILE_UPLOAD_TASK_ERROR = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_failed,
    message:
      translations?.file_upload_task_error,
    type: 'danger',
  };
};

export const FILE_UPLOAD_TASK_SUCCESS = (translations) => {
  return {
    ...DEFAULT_NOTIFICATION_SUCCESS,
    title: translations?.formManagement_successfully,
    message: translations?.file_upload_task_success,
    type: 'success',
  };
};
